import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

// Components
import { ActionButtonComponent } from './action-button.component';

@NgModule({
  declarations: [ActionButtonComponent],
  imports: [CommonModule, ButtonModule, RippleModule, TooltipModule],
  exports: [ActionButtonComponent],
})
export class ActionButtonModule {}
